"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminVerificationsResponseSchema = exports.AdminVerificationSchema = exports.VerificationStateSchema = exports.AdminMailDeliverySchema = exports.MailDeliveryStatusSchema = void 0;
const zod_1 = require("zod");
exports.MailDeliveryStatusSchema = zod_1.z.enum(['queued', 'sent', 'failed']);
exports.AdminMailDeliverySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kind: zod_1.z.literal('otp'),
    status: exports.MailDeliveryStatusSchema,
    attempts: zod_1.z.number().int(),
    provider: zod_1.z.enum(['log', 'postmark']),
    providerMessageId: zod_1.z.string().nullable(),
    /** The provider's own error text. Panel-only; never logged. */
    lastError: zod_1.z.string().nullable(),
    queuedAt: zod_1.z.iso.datetime(),
    sentAt: zod_1.z.iso.datetime().nullable(),
    failedAt: zod_1.z.iso.datetime().nullable(),
});
/**
 * `open` is still usable, `consumed` is the one that activated the account, `expired` ran out of
 * time unused, `voided` was closed by a resend or by too many wrong attempts (spec 7).
 */
exports.VerificationStateSchema = zod_1.z.enum(['open', 'consumed', 'expired', 'voided']);
exports.AdminVerificationSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    email: zod_1.z.string(),
    state: exports.VerificationStateSchema,
    attempts: zod_1.z.number().int(),
    createdAt: zod_1.z.iso.datetime(),
    expiresAt: zod_1.z.iso.datetime(),
    consumedAt: zod_1.z.iso.datetime().nullable(),
    deliveries: zod_1.z.array(exports.AdminMailDeliverySchema),
});
exports.AdminVerificationsResponseSchema = zod_1.z.object({ items: zod_1.z.array(exports.AdminVerificationSchema) });
//# sourceMappingURL=mail.js.map